const testimonials = [
    {
        name: "Melanie and Michael",
        picture: "melanie-michael.png",
        testimonial: `"I was going on a date a week, and with the premium service, I could see who matched up with me already and decide how I felt about them. I saw Michael's profile and swiped up because of my initial impression (handsome and working and graduated)... I am so in love with my husband. I could not have met him if it weren't for the Mutual app." - Melanie`
    },
    {
        name: "Riley and Delanie",
        picture: "couple2.png",
        testimonial: `"I had come home from my mission and swiping wasn’t doing it. Finally I decided to upgrade to Mutual Up, and the first and only match I had since was my now fiancée. She’s pretty rad. We got engaged in March of 2020 and after our wedding got postponed due to COVID, we are finally getting married. Thanks Mutual!"- Riley`
    }
]

export default testimonials